export default __webpack_public_path__ + "static/media/logo.44bce085.svg";